<template>
    <div>
        <el-dialog title="提示" width="426px" show-close :visible.sync="Authorize" :close-on-click-modal="false">
            <p>{{ content }}</p>
            <div slot="footer" class="dialog-footer">
                    <el-tooltip placement="top">
                        <img slot="content" :src="baseInfo.partner_auth_code" alt="" width="160" height="160">
                        <a href="javascript:;" class="fz-14 mr-20 link yx-color-text-regular">遇到困难？联系客服</a>
                    </el-tooltip>
                    <el-button type="primary" @click="Confirm">去授权</el-button>
                </div>
        </el-dialog>
        <authDialog ref="authDialog"></authDialog>
    </div>
</template>
<script>
import authDialog from './authDialog.vue'
import mixin from '@/mixins';
export default {
    components: {
        authDialog
    },
    mixins: [mixin],
    data() {
        return {
            Authorize: false,
            link: '',
            content: '',
            platformId: ''
        }
    },
    methods: {
        initSynchro(value, content, platformId) {
            this.content = content
            this.link = value
            this.Authorize = true
            this.platformId= platformId
        },
        Confirm() {
            var a = document.createElement("a") // 创建a标签
            a.style.display="none" // 隐藏a标签
            a.href= this.link // 文件下载地址
            a.target = "_blank"
            document.body.appendChild(a) // 将a标签插入到页面中
            a.click() // 强制触发a便签的点击事件
            document.body.removeChild(a) // 移除a标
            const { platformId } = this
            this.Authorize = false
            this.$refs.authDialog.show(this.link, platformId)
        }
    }
}
</script>
<style lang='less' scoped>
.warn-img {
    width: 16px;
    height: 16px;
}
</style>